import { render, staticRenderFns } from "./proinfo.vue?vue&type=template&id=f4c75782&scoped=true"
import script from "./proinfo.vue?vue&type=script&lang=js"
export * from "./proinfo.vue?vue&type=script&lang=js"
import style0 from "./proinfo.vue?vue&type=style&index=0&id=f4c75782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c75782",
  null
  
)

export default component.exports